import React, { Component } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LayoutExterno } from './components/LayoutExterno';
import { Home } from './components/Home';
import { FileUpload } from './components/FileUpload';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { AddActExtracurricular } from './components/AddActExtracurricular';
import { ActExtracurricular } from './components/ActExtracurricular';
import { ActExtraEstudiante } from './components/ActExtraEstudiante';
import { Insignias } from './components/Insignias';
import { Reporte } from './components/Reporte';
import { Autenticado } from './components/Autenticado';
import { UpdateGestion } from './components/UpdateGestion';
import { GestionActividad } from './components/GestionActividad';
import { GestionActividadPagination } from './components/GestionActividadPagination';
import { ConsultarPerfil } from './components/ConsultarPerfil';
import { ConsultarInsignias } from './components/ConsultarInsignias';
import { ConsultarReportes } from './components/ConsultarReportes';
import { Spinner } from 'reactstrap';
//import { Cargando } from './components/Cargando';

import history from "./historyBeta";
import { createBrowserHistory } from "history";
import { AppContext } from './AppContext';
import url from "./components/variables/url.js";
import CasClient, { constant } from "react-cas-client";
import { authService } from './services/auth.service';
import './custom.css';
import Certificado from './components/Certificado';

/*const CAS_PARAMS = url.cas.split("://");*/
const CAS_PARAMS = process.env.REACT_APP_CAS.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

const homepage = process.env.REACT_APP_EXP;
const localBack = process.env.REACT_APP_BACK;

const hist = createBrowserHistory();

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);

    this.state = {
      username: null,
      currentUser: null,
      loading: true,
    };

    const { username } = this.state;

    /*Se debe estar logeado excepto para autenticacion de certificados.*/
    if (!username && !hist.location.pathname.includes('/Autenticado/') && !hist.location.pathname.includes('/Descargar/')) {
        casClient
            .auth()
            .then(successRes => {
                //alert("asdasdasd");
                console.log("App successRes = " + JSON.stringify(successRes)); this.setState({ username: successRes.user });
                history.replace(successRes.currentPath);
            })
            .catch(errorRes => { console.log("App errorRes = " + JSON.stringify(errorRes)) });
    }
  }

    //constructor(props) {
    //    super(props);

    //    this.state = {
    //        username: null,
    //        currentUser: null,
    //        loading: true,
    //    };

    //    const { username } = this.state;
    //    /*Se debe estar logeado excepto para autenticacion de certificados.*/
    //    if (!username && !hist.location.pathname.includes('/Autenticado/') && !hist.location.pathname.includes('/Descargar/')) {
    //        window.location.href = 'https://www.bienestar.espol.edu.ec/sistema-de-experiencia-estudiantil';
    //    }
    //}

  componentDidMount() {

      //alert(hist.location.pathname);

      if (hist.location.pathname == "/") {
          window.location.href = 'https://www.bienestar.espol.edu.ec/sistema-de-experiencia-estudiantil';
      }

      console.log("app state = " + JSON.stringify(this.state));

    this.subscription = authService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.idpersona) {
          this.setState({ currentUser: currentUser, loading: false });
          //console.log(this.state.currentUser.roles);
          //console.log(this.state.currentUser.usuario);
      }
    });
  }

    componentDidUpdate() {
        //alert(hist.location.pathname);

        if (hist.location.pathname == "/") {
            window.location.href = 'https://www.bienestar.espol.edu.ec/sistema-de-experiencia-estudiantil';
        }

        const { username, currentUser } = this.state;
        if (username && !currentUser) {
          authService.login(username);
        }

  }

  componentWillUnmount() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  logout() {
    casClient.logout();
  }

  render () {
    const page = (
       <AppContext.Provider value={this.state.currentUser}>
       <Router history={hist}>
       <Switch>
         <Route path='/Admin' render={(props) => <Layout {...props} />} />
            <Route exact path={homepage + 'Autenticado/:codigo'} render={(props) => <LayoutExterno {...props} />} />
            <Route exact path={homepage + 'Descargar/:id'} render={(props) => {
              fetch(localBack + '/api/FileUpload/DescargarEvidencia/' + props.match.params["id"], {
                method: 'GET',
              })
                .then(response => {
                  return response.json();
                })
                .then(data => {
                  if (data !== '') {

                    let a = document.createElement('a');
                    a.href = "data:application/pdf;base64," + data + "";
                    a.download = "certificado-" + ".pdf";
                    a.click();
                  }
                });
            }
              } />
                    <Route>
                        <Layout>
                            <Switch>
                                {/*<Route exact path={homepage} component={Home} />*/}
                                <Route exact path={homepage} render={(props) => { window.location.href = 'https://www.bienestar.espol.edu.ec/sistema-de-experiencia-estudiantil'; }} />
                                {/*<Route path={homepage} render={(props) => { window.location.href = 'https://www.bienestar.espol.edu.ec/sistema-de-experiencia-estudiantil'; }} />*/}
                                <Route path={homepage + 'Inicio'} component={Home} />
                                <Route path={homepage+'counter'} component={Counter} />

                                <Route path={homepage +'fetch-data'} component={FetchData} />
                                <Route path={homepage +'Act-Ext'} component={ActExtracurricular} />
                                <Route path={homepage +'Act-Est'} component={ActExtraEstudiante} />

                                <Route path={homepage +'Add-Act'} component={AddActExtracurricular} />
                                <Route path={homepage +'Edit-Act/:id'} component={AddActExtracurricular} />
                                <Route path={homepage +'New-Act/:categoria/:tipo'} component={AddActExtracurricular} />
                                <Route path={homepage +'Insignia'} component={Insignias} />
                                <Route path={homepage +'Reporte'} component={Reporte} />

                                <Route exact path={homepage + 'ConsultarReportes'} component={ConsultarReportes} />
                                <Route exact path={homepage + 'ConsultarPerfil'} component={ConsultarPerfil} />
                                <Route exact path={homepage + 'ConsultarInsignias'} component={ConsultarInsignias} />
                                <Route exact path={homepage + 'GestionActividad'} component={GestionActividadPagination} />
                                <Route exact path={homepage +'Gestion/:id'} component={UpdateGestion} />
                                <Route exact path={homepage + 'CargaMasiva'} component={FileUpload} />
                                <Route exact path={homepage + 'Verificar/:codigo'} component={Autenticado} />
                            {/*<Route exact path='*' component={Home} />*/}
                            </Switch>
                        </Layout>                        
                    </Route>

                    <Route>
                       <Switch>
                            <Route exact path={homepage + 'Autenticado/:codigo'} component={LayoutExterno} />                            
                       </Switch>
                    </Route>              
                        
        </Switch>
        </Router>
      </AppContext.Provider>
      );

    if (this.state.loading) {
        return (
            <div style={{ textAlign: "center" }}>
                <br/>
                <Spinner animation="grow" />
                <em> Cargando</em>
            </div>
        )
    } 
    else {
        return page
    }

  }
}
